<template>
  <div class="type-textarea wordcount">
    <textarea
      ref="textarea"
      id="recce-notes"
      name="notes"
      :class="[size]"
      v-model="current"
      :disabled="disabled"
    ></textarea>
    <div class="word-count">Word count: {{ words }}</div>
  </div>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: "medium",
    },
    value: {
      required: true,
    },
    autoAdjustHeight: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      current: this.value,
      words: 0,
    };
  },

  watch: {
    current(now, was) {
      this.updateWordCount();
      this.adjustHeight();
      this.$emit("input", this.current ? this.current : "");
    },

    value(now) {
      if (this.value != this.current) {
        this.current = this.value;
      }
    },
  },

  created() {
    this.updateWordCount();
  },

  mounted() {
    this.adjustHeight();
  },

  methods: {
    updateWordCount() {
      let trimmed = this.current.replace(/^\s+|\s+$/, "");
      this.words = trimmed.length ? trimmed.split(/\s+/).length : 0;
    },
    adjustHeight() {
      if (this.autoAdjustHeight) {
        var lines = this.current.split(/\r|\r\n|\n/);
        var count = lines.length;
        this.$refs.textarea.style.setProperty("height", "auto");
        if (count > 3) {
          this.$refs.textarea.setAttribute("rows", count);
        } else {
          this.$refs.textarea.setAttribute("rows", 3);
        }
      }
    },
  },
};
</script>